import { useContext } from "react";
import InputMask from "react-input-mask";
import { Input } from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";
import DisabledContext from "antd/es/config-provider/DisabledContext";

type Props = {
  value?: string;
  onChange?: (value: string) => void;
  size?: SizeType;
  disabled?: boolean;
};

export const PhoneMaskedInput = ({
  value,
  onChange,
  size = "middle",
  disabled,
}: Props) => {
  const contextDisabled = useContext(DisabledContext);
  const isDisabled = disabled ?? contextDisabled;

  return (
    <InputMask
      mask='(999) 999-9999'
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      disabled={isDisabled}
    >
      {/* @ts-ignore - react-input-mask render prop typing */}
      {(inputProps: any) => <Input {...inputProps} size={size} disabled={isDisabled} />}
    </InputMask>
  );
};
